import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconAddAnnotation({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M2 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.236c.258-.289.462-.627.593-1H12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v5.17a2.998 2.998 0 0 0-1 .594V4zm3.5 1a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm2 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM4 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
        </svg>
    );
}

export default IconAddAnnotation;
